module.exports = __webpack_public_path__ + "static/media/jt8.4eaafa37.png";